/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Input, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { ModalController, NavParams, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { UserService } from '@shared/services/user.service';
import { MatchService } from 'src/app/services/match.service';
import { UtilService } from '@shared/utils/util';
import { PicturesPage } from 'src/app/pages/pictures/pictures.page';
import { ChatPage } from 'src/app/pages/chat/chat.page';
import { Router } from '@angular/router';

@Component({
  selector: 'app-vegmatch-modal',
  templateUrl: './vegmatch-modal.component.html',
  styleUrls: ['./vegmatch-modal.component.scss'],
})
export class VegmatchModalComponent {
  @Input() refreshMyData!: () => Promise<void>;

  // Outputs para comunicação com o componente pai
  @Output() boostClicked = new EventEmitter<void>();
  @Output() purchaseClicked = new EventEmitter<string>();
  
  public newMatchesInfo: any = [];
  public userData: any;
  public pictures: any = [];
  @ViewChild('swiper') swiperRef: ElementRef | undefined;

  constructor(private modalCtrl: ModalController,
    public translate: TranslateService,
    public matchService: MatchService,
    public userService: UserService,
    public toastCtrl: ToastController,
    public util: UtilService,
    private analytics: AnalyticsService,
    public navParams: NavParams,
    private router: Router,
  ) {
    this.userData = this.navParams.get('userData');
    this.newMatchesInfo = this.navParams.get('newMatchesInfo');
  }

  async ionViewWillEnter() {
    Preferences.set({key:'MATCHES_MODAL', value: JSON.stringify(new Date())}).then((_val) => {
      console.log('MATCHES_MODAL saved to DB');
    });

    this.loadMatchesPictures();
    this.loadUserPicture();

  }

  loadUserPicture() {
    this.userData.profilePic = PicturesPage.gray;// Set initially
    
    let i : number = 0;
    for(i=0; i<9; i++){
      const aPicName = 'picture' + i;
      const aPic = this.userData[aPicName];
      if(aPic != null){
        this.userData.profilePic = this.userService.getImageURL(aPic.$oid);
        break;
      }
    }
  }

  loadMatchesPictures() {
    for (let i = 0; i < this.newMatchesInfo.length; i++) {
      const aSoul = this.newMatchesInfo[i];
      aSoul.firstPic = PicturesPage.loading;// Set initially
      aSoul.noPictureText = 'Loading...';
      const _aFile = aSoul._id.$oid + '.jpg';
      let picnum: number;
      let quantPic: number = 0;
      for (picnum = 0; picnum < 9; picnum++) {
        const aPic: string = "picture" + picnum;
        if (aSoul[aPic] != null) {
          quantPic++;
        }
      }
      aSoul.quantPic = quantPic;
      this.useURLDirectly(aSoul)
    }
  }

  useURLDirectly(aSoul: any) {
    let _url;
    let picnum: number;
    let hasPic: boolean = false;
    for (picnum = 0; picnum < 9; picnum++) {
      const aPic: string = "picture" + picnum;
      if (aSoul[aPic] != null) {
        hasPic = true;
        const url = this.userService.getImageURL(aSoul[aPic].$oid);
        aSoul.firstPic = url;
        break;
      }
    }
    if (!hasPic) {
      aSoul.firstPic = PicturesPage.noImage;
      aSoul.noPictureText = '';
    }

  }

  onSlideChange(): void {
    const swiperEl = this.swiperRef?.nativeElement;
    const swiperInstance = swiperEl?.swiper;
  
    if (!swiperInstance) return;
  
    const activeIndex = swiperInstance.activeIndex;
    const currentMatch = this.newMatchesInfo[activeIndex];
  
    if (!currentMatch.read) {
      currentMatch.read = true;
  
      //TODO: Now update in DB
    }
  }

  openCurrentChat(): void {
    const swiperEl = this.swiperRef?.nativeElement;
    const swiperInstance = swiperEl?.swiper;
  
    if (swiperInstance) {
      const activeIndex = swiperInstance.activeIndex;
      const currentMatch = this.newMatchesInfo[activeIndex];
      this.chat(currentMatch);
    }
  }

    async chat(soulToChat : any){
      const modal = this.modalCtrl.create({
        component: ChatPage,
        componentProps: {
        me: this.userData,
        otherSoul : soulToChat,
        fromVegmatchModal: true,
        },
        showBackdrop:true});
        this.dismiss();
      
      (await modal).onDidDismiss().then((val) => {
      
        if (val && val.data === "logout") {
          this.router.navigateByUrl('/login');
        } else if (val && val.data === "shouldRefreshList") {
          this.matchService.loadMatches(false);
        }
      });
  
      (await modal).present();
    }
  

  nextSlide(): void {
    const swiperEl = this.swiperRef?.nativeElement;
    swiperEl?.swiper?.slideNext();
  }
  
  prevSlide(): void {
    const swiperEl = this.swiperRef?.nativeElement;
    swiperEl?.swiper?.slidePrev();
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

}